import useToggleDriveMode from "@/components/AppHeader/hooks/useToggleDriveMode";
import AnimatedToggle from "@/components/ui/animated-toggle";
import { Button } from "@/components/ui/button";
import { CursorType } from "@/store/globalSettingsSlice";
import { PlayIcon, SquareMousePointer } from "lucide-react";
import React, { Fragment } from "react";
import { useSelector } from "react-redux";

export const InteractDesignToggle = () => {
  const cursorType = useSelector(
    (state: any) => state.globalSettings.cursorType
  );
  const { toggleCursor } = useToggleDriveMode();

  return (
    <Button
      variant="primary"
      size="sm"
      className="rounded-md px-2 flex gap-1 text-xs font-medium ml-1.5"
      onClick={() => toggleCursor()}
    >
      {cursorType === CursorType.Drive ? (
        <Fragment>
          <SquareMousePointer className="size-4" />
          Design
        </Fragment>
      ) : (
        <Fragment>
          <PlayIcon className="size-4" />
          Interact
        </Fragment>
      )}
    </Button>
  );
};

export default React.memo(InteractDesignToggle);
